// extracted by mini-css-extract-plugin
export var columnItem = "_9x-3";
export var columnItemDraggable = "_9x-4";
export var dragHandle = "_9x-0";
export var dragHandleHovered = "_9x-1";
export var dropdown = "_9x-5";
export var dropdownContent = "_9x-7";
export var dropdownInner = "_9x-6";
export var filterDropdownHeader = "_9x-8";
export var icon = "_9x-2";
export var sectionDivider = "_9x-9";